<template>
  <div class="container">
    <app-table v-model="controls" :api="apiProductos" :fields="fields">
      <template slot="header">
        <i class="fas fa-drumstick-bite"></i> Productos
      </template>
      <!-- Un Row -->
      <template slot="tr-item" slot-scope="product">
        <td class="text-right">
          <texto-resaltado :text="product.row.id + ''" :query="controls.query">
          </texto-resaltado>
        </td>
        <td>
          <texto-resaltado :text="product.row.nombre" :query="controls.query">
          </texto-resaltado>
        </td>
        <td>
          {{ product.row.categoria_id | catNombre }}
        </td>
        <td>
          <texto-resaltado :text="product.row.clave" :query="controls.query">
          </texto-resaltado>
        </td>
        <td class="text-right">{{ product.row.unit_medida }}</td>
        <td class="text-right">{{ product.row.modified | dateTime }}</td>
        <td class="actions">
          <router-link
            :class="btnClass(product.row)"
            :to="{ name: 'productoPublicar', params: { id: product.row.id } }"
          >
            <i class="fas fa-cart-plus"></i> {{ btnText(product.row) }}
          </router-link>
        </td>
      </template>
      <!-- Fin row -->
    </app-table>
    <pre></pre>
  </div>
</template>

<script>
import Producto from "../apis/Producto";

export default {
  data() {
    return {
      apiProductos: Producto,
      controls: {
        relations: ["publicado"]
      },
      fields: [
        { display: "Folio", field: "id", sort: true },
        { display: "Nombre", field: "nombre", sort: true },
        { display: "Categoria", field: "categoria_id", sort: true },
        { display: "Clave", field: "clave", sort: true },
        { display: "Unidad", field: "unit_medida", sort: true },
        { display: "Modificado", field: "modified", sort: true },
        { display: "Acciones" }
      ]
    };
  },
  methods: {
    btnClass(p) {
      return p.publicado
        ? "btn btn-warning btn-block"
        : "btn btn-success btn-block";
    },
    btnText(p) {
      return p.publicado ? "Editar" : "Publicar";
    }
  },
  computed: {}
};
</script>
